module.exports = __webpack_public_path__ + "img/27-l.d2873d93.png";